import { render, staticRenderFns } from "./BatchAccountStatusUpdate.vue?vue&type=template&id=1e7beec2&"
import script from "./BatchAccountStatusUpdate.vue?vue&type=script&lang=js&"
export * from "./BatchAccountStatusUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports